import { Button } from "@planningcenter/tapestry-react"
import { string, bool, func, number } from "prop-types"
import { Link } from "@reach/router"

const HeaderButtons = ({ navigationPathNew, enableAddSection, limit, limitMet, navigate }) => {
  const handleAddQuestion = () => {
    if (limitMet) {
      return alertModal(
        {
          title: "Are you sure you want to add another question?",
          text:
            `A maximum of ${limit} questions is recommended so that each ` +
            "section of the signup is manageable for registrants to complete " +
            "in the allotted time. If the registration is not completed in " +
            "the allotted time, it will expire.",
          type: "warning",
          confirmButtonText: "Yes, add a question",
          showCancelButton: true,
          cancelButtonText: "No, don't add a question",
          closeOnConfirm: true,
          xhrOnCancel: true
        },
        resp => {
          if (resp) navigate(navigationPathNew)
        }
      )
    } else {
      navigate(navigationPathNew)
    }
  }

  return (
    <div className="d-f ai-c jc-fe" css={{ gap: "0.5rem" }}>
      <Button title="Add a question" theme="create" onClick={handleAddQuestion} />
      {enableAddSection && (
        <Link className="quiet-create-btn btn2" to={navigationPathNew} state={{ kind: "header" }}>
          Add section heading
        </Link>
      )}
    </div>
  )
}

HeaderButtons.propTypes = {
  navigationPathNew: string,
  enableAddSection: bool,
  limit: number,
  limitMet: bool,
  navigate: func
}

export default HeaderButtons
